import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useSelector } from 'react-redux';
import imageUrls from '../images/imageUrls';
import { getActiveError } from '../store/error/selectors';
import { OptionalFormattedMessage } from '../views-components/OptionalFormattedMessage';
import { StepTitle } from '../views-components/StepTitle';
import { StyledUILink } from '../views-components/TextInput.styles';
import { BaseErrorView } from './BaseErrorView';
import { ErrorKey } from './ErrorKey';
import { Image } from 'foundations-components/transitional/components/Image';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CentredButtonText = styled.div.withConfig({
  displayName: "StandardError__CentredButtonText"
})(["& span{display:block;text-align:center;}"]);
const StandardError = ({
  errorKey = ErrorKey.InternalError,
  handleButtonClick,
  handleLinkClick,
  hasImage = true,
  imageURL = imageUrls.computerError,
  linkToHelpResources = false,
  onSentenceWithLinkClick,
  href = '',
  renderContent,
  isButtonLoading = false,
  showSubtitle = true,
  buttonMessageKey,
  titleMessageKey
}) => {
  const getHelpResourcesLink = () => {
    return `https://help.hubspot.com/`;
  };
  const {
    isDesktop
  } = useResponsiveness();
  const currentError = useSelector(getActiveError);
  const renderImage = () => {
    return hasImage && /*#__PURE__*/_jsx(Image, {
      alt: "Error image",
      blockSize: "auto",
      inlineSize: "auto",
      margin: "auto",
      marginBlockEnd: "800",
      responsive: true,
      src: imageURL
    });
  };
  const renderTitle = () => {
    return /*#__PURE__*/_jsx(StepTitle, {
      message: titleMessageKey || `error.${errorKey}.title`,
      stepKey: errorKey
    });
  };
  const renderSubtitle = () => {
    return /*#__PURE__*/_jsx(OptionalFormattedMessage, {
      message: `error.${errorKey}.subtitle`
    });
  };
  const renderButton = () => {
    return handleButtonClick && /*#__PURE__*/_jsx(LoadingButton, {
      "data-selenium": `${errorKey}_button`,
      loading: isButtonLoading,
      margin: "auto",
      marginBlock: "500",
      use: "primary",
      onClick: handleButtonClick,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: buttonMessageKey || `error.${errorKey}.buttonCTA`
      })
    });
  };
  const renderLink = () => {
    return handleLinkClick && /*#__PURE__*/_jsx(CentredButtonText, {
      children: /*#__PURE__*/_jsx(Button, {
        "data-selenium": `${errorKey}_link`,
        use: "link",
        onClick: handleLinkClick,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `error.${errorKey}.linkCTA`
        })
      })
    });
  };
  const renderSentenceWithLink = () => {
    return onSentenceWithLinkClick && /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: `error.${errorKey}.sentenceWithLink`,
      options: {
        link: /*#__PURE__*/_jsx(StyledUILink, {
          href: href,
          onClick: onSentenceWithLinkClick,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `error.${errorKey}.link`
          })
        })
      }
    });
  };
  const renderLinkToHelpResources = () => {
    return linkToHelpResources && /*#__PURE__*/_jsx(View, {
      as: "div",
      marginBlockStart: "500",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `error.${errorKey}.helpResourcesSentence`,
        options: {
          helpResourcesLink: /*#__PURE__*/_jsx(StyledUILink, {
            external: true,
            href: getHelpResourcesLink(),
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: `error.${errorKey}.checkHelpResources`
            })
          })
        }
      })
    });
  };
  const maxWidth = currentError === ErrorKey.AlreadyAPartner ? '90%' : '75%';
  return /*#__PURE__*/_jsx(BaseErrorView, {
    errorKey: errorKey,
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      marginInline: "auto",
      maxInlineSize: isDesktop ? maxWidth : undefined,
      children: [renderImage(), renderTitle(), showSubtitle && renderSubtitle(), renderContent && renderContent(), renderButton(), renderLink(), renderSentenceWithLink(), renderLinkToHelpResources()]
    })
  });
};
export default StandardError;